import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { TAccountDeletionData } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetAccountsDeletionData = async ({
  startDate,
  endDate,
  limit
}: {
  startDate: Date;
  endDate: Date;
  limit: number;
}): Promise<{
  data: TAccountDeletionData[];
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<TAccountDeletionData[]>(
    `communications/getAccountsDeletionData`,
    {
      startDateObject: getDateAsObject(startDate),
      endDateObject: getDateAsObject(endDate),
      limit
    }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (
    status === "ERROR" &&
    isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      et3Error
    )
  ) {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: [],
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  }
};
